/**
 * Producto en el formato que recibe addToCart / addMultipleToCart.
 *
 * Todos los "agregar al carrito" con productos del catálogo (tarjeta en home,
 * listados y buscador, ficha y "Agregar los N") lo arman acá, así el carrito y
 * Product Added to Cart (Mixpanel, task-1635) reciben los mismos campos venga de
 * donde venga. `analytics` (marca, distribuidor, tags, categorías) lo trae el
 * backend en el catálogo del build y en la API en vivo, incluida la búsqueda.
 *
 * @param {object} item     producto del catálogo (internal_id, id, images, ...)
 * @param {object} opciones cantidad, stock validado y una imagen de respaldo
 */
export const buildCartItem = (item, { quantity = 1, stockQuantity, fallbackImage = '' } = {}) => {
  const src = item.images?.[0]?.src;

  return {
    product_id: item.internal_id,
    wordpress_id: item.id,
    sku: item.sku,
    name: item.name,
    slug: item.slug,
    price: item.price,
    sale_price: item.sale_price,
    pack_quantity: item.pack_quantity,
    image: src ? `${process.env.BASE_FRONT}${src}` : fallbackImage,
    description: item.description,
    quantity,
    tags: item.tags,
    stock_quantity: stockQuantity ?? item.stock_quantity,
    total_sales: item.total_sales,
    box: item.box,
    categories: item.categories,
    analytics: item.analytics,
  };
};
